/**
 * 侧边栏菜单项配置 - 业务分类优化版
 */

import React from 'react';
import { MenuProps } from 'antd';
import {
    UploadOutlined,
    BarChartOutlined,
    SyncOutlined,
    BookOutlined,
    CheckCircleOutlined,
    SettingOutlined,
    EnvironmentOutlined,
    TagsOutlined,
    CarOutlined,
    DollarOutlined,
    RobotOutlined,
    RocketOutlined,
    ApartmentOutlined,
    ShoppingOutlined,
    ShopOutlined,
    ContainerOutlined,
    CloudUploadOutlined,
    LinkOutlined,
    SendOutlined,
    UnorderedListOutlined,
    AuditOutlined,
    ToolOutlined,
    AimOutlined,
    FileSearchOutlined,
    HomeOutlined,
    DatabaseOutlined,
    InboxOutlined,
    TruckOutlined,
    TeamOutlined,
} from '@ant-design/icons';

export const SIDEBAR_MENU_ITEMS: MenuProps['items'] = [
    // ==================== 销售与运营 ====================
    {
        key: 'sales-group',
        label: '销售与运营',
        type: 'group',
    },
    {
        key: 'dashboard',
        icon: <HomeOutlined />,
        label: '仪表盘',
    },
    {
        key: 'analysis',
        icon: <BarChartOutlined />,
        label: '数据分析',
    },
    {
        key: 'aba-analysis',
        icon: <BarChartOutlined />,
        label: 'ABA分析',
    },
    {
        key: 'data-center',
        icon: <DatabaseOutlined />,
        label: '数据中心',
    },
    {
        key: 'store-management',
        icon: <ShopOutlined />,
        label: '店铺管理',
    },
    {
        key: 'order-list',
        icon: <UnorderedListOutlined />,
        label: '订单列表',
    },
    {
        key: 'operation-strategy',
        icon: <RocketOutlined />,
        label: '运营策略',
    },

    // ==================== 产品管理 ====================
    {
        key: 'product-group',
        label: '产品管理',
        type: 'group',
    },
    {
        key: 'sku-management',
        icon: <ShoppingOutlined />,
        label: 'SKU管理',
    },
    {
        key: 'sku-mapping',
        icon: <LinkOutlined />,
        label: 'SKU映射',
    },
    {
        key: 'brand-management',
        icon: <TagsOutlined />,
        label: '品牌管理',
    },

    // ==================== 采购管理 ====================
    {
        key: 'procurement-group',
        label: '采购管理',
        type: 'group',
    },
    {
        key: 'procurement-suppliers',
        icon: <TeamOutlined />,
        label: '供应商管理',
    },
    {
        key: 'procurement-orders',
        icon: <ContainerOutlined />,
        label: '采购订单',
    },

    // ==================== 仓储管理 ====================
    {
        key: 'warehouse-group',
        label: '仓储管理',
        type: 'group',
    },
    {
        key: 'fba-inventory',
        icon: <InboxOutlined />,
        label: 'FBA库存分析',
    },
    {
        key: 'replenishment-group',
        label: '智能补货',
        icon: <SyncOutlined />,
        children: [
            { key: '/supply-chain/replenishment', label: '补货建议' },
            { key: '/supply-chain/replenishment/config', label: '规则配置' }
        ]
    },

    // ==================== 物流管理 ====================
    {
        key: 'logistics-group',
        label: '物流管理',
        type: 'group',
    },
    {
        key: 'logistics',
        icon: <TruckOutlined />,
        label: '头程物流',
    },
    {
        key: 'logistics-tracker',
        icon: <EnvironmentOutlined />,
        label: '全链路追踪',
    },
    {
        key: 'logistics-providers',
        icon: <TeamOutlined />,
        label: '物流服务商',
    },
    {
        key: 'shipping-management',
        icon: <CarOutlined />,
        label: '配送管理',
    },

    // ==================== 营销推广 ====================
    {
        key: 'marketing-group',
        label: '营销推广',
        type: 'group',
    },
    {
        key: 'marketing/advertising',
        icon: <BarChartOutlined />,
        label: '广告数据中心',
    },
    {
        key: 'marketing/influencers',
        icon: <TeamOutlined />,
        label: '红人营销',
    },

    // ==================== 财务管理 ====================
    {
        key: 'finance-group',
        label: '财务管理',
        type: 'group',
    },
    {
        key: 'finance-dashboard',
        icon: <DollarOutlined />,
        label: '利润报表',
    },
    {
        key: 'finance-cost-config',
        icon: <SettingOutlined />,
        label: '成本配置',
    },
    {
        key: 'exchange-rate',
        icon: <DollarOutlined />,
        label: '汇率管理',
    },

    // ==================== 行政管理 ====================
    {
        key: 'administration-group',
        label: '行政管理',
        type: 'group',
    },
    {
        key: 'admin-statistics',
        icon: <AuditOutlined />,
        label: '业绩统计',
    },
    {
        key: 'admin-dept-kpi',
        icon: <ToolOutlined />,
        label: '部门KPI',
    },
    {
        key: 'admin-target',
        icon: <AimOutlined />,
        label: '目标设置',
    },
    {
        key: 'admin-assessment',
        icon: <FileSearchOutlined />,
        label: 'KPI考核',
    },
    {
        key: 'organization',
        icon: <ApartmentOutlined />,
        label: '组织管理',
    },

    // ==================== 系统设置 ====================
    {
        key: 'system-group',
        label: '系统设置',
        type: 'group',
    },
    {
        key: 'data-management',
        icon: <UploadOutlined />,
        label: '数据管理',
    },
    {
        key: 'data-check',
        icon: <CheckCircleOutlined />,
        label: '数据核对',
    },
    {
        key: 'config-manager',
        icon: <SettingOutlined />,
        label: '配置中心',
    },
    {
        key: 'prompt-management',
        icon: <RobotOutlined />,
        label: 'AI提示语',
    },
    {
        key: 'metrics-guide',
        icon: <BookOutlined />,
        label: '指标说明',
    },
];
